export default __webpack_public_path__ + "static/media/client5.59032bb0.png";